import styles from "./Labels.module.css";

const DevModeLabel = () => {
  return (
    <>
      {process.env?.REACT_APP_MODE === "dev" && (
        <div className={styles.container}>
          <div className={styles.text}>
            <span style={{ animationDelay: "0ms" }}>D</span>
            <span style={{ animationDelay: "100ms" }}>e</span>
            <span style={{ animationDelay: "200ms" }}>v</span>
            <span style={{ animationDelay: "300ms" }}>e</span>
            <span style={{ animationDelay: "400ms" }}>l</span>
            <span style={{ animationDelay: "500ms" }}>o</span>
            <span style={{ animationDelay: "600ms" }}>p</span>
            <span style={{ animationDelay: "700ms" }}>e</span>
            <span style={{ animationDelay: "800ms" }}>r</span>
            <span style={{ animationDelay: "900ms" }}> </span>
            <span style={{ animationDelay: "1000ms" }}>M</span>
            <span style={{ animationDelay: "1100ms" }}>o</span>
            <span style={{ animationDelay: "1200ms" }}>d</span>
            <span style={{ animationDelay: "1300ms" }}>e</span>
          </div>
        </div>
      )}
      {process.env?.REACT_APP_MODE === "qa" && (
        <div className={styles.container}>
          <div className={styles.text}>
            <span style={{ animationDelay: "0ms" }}>Q</span>
            <span style={{ animationDelay: "100ms" }}>A</span>
            <span style={{ animationDelay: "200ms" }}> </span>
            <span style={{ animationDelay: "300ms" }}>M</span>
            <span style={{ animationDelay: "400ms" }}>o</span>
            <span style={{ animationDelay: "500ms" }}>d</span>
            <span style={{ animationDelay: "600ms" }}>e</span>
          </div>
        </div>
      )}
    </>
  );
};

export default DevModeLabel;
